export const setGameOptions = GameOptions => ({
  type: 'SET_GAMEOPTIONS',
  payload: { GameOptions },
});

export function loseLife() {
  return {
    type: 'LOSE_LIFE'
  }
}

// export function setTutorialSeen() {
//   return {
//     type: 'TUTORIAL_SEEN'
//   }
// }

// export function completeLevel(currentLevel) {
//   return {
//     type: "COMPLETE_LEVEL",
//     payload: currentLevel
//   }
// }

// export function selectSyllable() {
//   return {
//     type: 'SELECT_SYLLABLE'
//   }
// }

// export function completeWord() {
//   return {
//     type: 'COMPLETE_WORD'
//   }
// }

// export function gotoMenu() {
//   return {
//     type: 'GO_TO_MENU'
//   }
// }

// export function updateLevel(level) {
//   return{
//     type: 'SET_LEVEL',
//     padload: level
//   }
// }

// export function setWord(num) {

//   return {
//     type: 'SET_WORD',
//     payload: num
//   }
// }



// export function setLives(lives) {
//   return {
//     type: "SET_LIVES",
//     payload: lives
//   }
// }

// export function resetLevel(lives) {
//   return {
//     type: 'RESET_LEVEL',
//     payload: lives
//   }
// }

// export function toggleNeedsReview () {
//   return {
//     type: 'TOGGLE_REVIEW'
//   }
// }


// WEBPACK FOOTER //
// ./src/actions/index.js